import { Component } from '@angular/core';
import { IPluginPreviewComponent } from '../../../../../../interfaces/plugin-preview-component.interface';
import { AdditionalInformationData } from '../../../../../../models/wizard-plugin-models/additional-information-data';

@Component({
  selector: 'app-additional-information-preview',
  templateUrl: './additional-information-preview.component.html',
  styleUrl: './additional-information-preview.component.css'
})
export class AdditionalInformationPreviewComponent implements IPluginPreviewComponent {
  
   public previewData: AdditionalInformationData | undefined;
  
    setData(data: any): void {
      if (data) {
        this.previewData = data as AdditionalInformationData;
      }
    }

}
